import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

export const QuantitySelect = ({
  form,
  showQuantity = true,
  className,
}: {
  form: any;
  showQuantity?: boolean;
  className?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FormField
      control={form.control}
      name='quantity'
      render={({ field }) => (
        <div className='flex flex-row justify-between'>
          <FormItem className={cn('flex w-full flex-col gap-2.5 space-y-0 lg_space-y-0')}>
            {showQuantity && (
              <FormLabel className='mr-2 font-sans text-[16px] font-extrabold leading-normal text-primary'>
                Quantity:
              </FormLabel>
            )}
            <FormControl>
              <p className='relative w-full'>
                <select
                  {...field}
                  className={cn(
                    'h-[40px] w-20 w-full appearance-none rounded-[10px] border-[2px] border-solid border-[#ddd] pl-2.5 pr-8 outline-none lg_h-[54px]',
                    className,
                  )}
                  onFocus={() => setIsOpen(true)}
                  onBlur={() => setIsOpen(false)}
                >
                  {[...Array(10)].map((_, i) => (
                    <option
                      key={i + 1}
                      value={(i + 1).toString()}
                    >
                      {i + 1}
                    </option>
                  ))}
                </select>
                <ChevronDown
                  className={`pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 transition-transform${isOpen ? 'rotate-180' : ''}`}
                  size={16}
                />
              </p>
            </FormControl>
          </FormItem>
        </div>
      )}
    />
  );
};
